import { Component } from '@angular/core';
import { BaseMortgageApplicationComponent } from '../../../pages/base-mortgage-application.component';
import { PropertyOccupant } from './../../../models/property-occupant.model';
import { MortgageApplicationStore } from './../../../services/mortgage-application-store';

@Component({
  selector: 'boi-your-property-details',
  templateUrl: './your-property-details.component.html',
  styleUrls: ['./your-property-details.component.scss']
})
export class YourPropertyDetailsComponent extends BaseMortgageApplicationComponent {
  private readonly maxPropertyOccupants = 50;

  constructor(protected mortgageApplicationStore: MortgageApplicationStore) {
    super(mortgageApplicationStore);
  }

  isRelationshipToYouDetailsVisible(propertyOccupant: PropertyOccupant): boolean {
    if (propertyOccupant.RelationshipWithApplicantCode === this.referenceDataOptionLists.RelationshipTypeOther) {
      return true;
    }

    return false;
  }

  nullifyPropertyOccupantRelationshipDetails(propertyOccupant: PropertyOccupant): void {
    if (!this.isRelationshipToYouDetailsVisible(propertyOccupant)) {
      propertyOccupant.RelationshipToYouDetails = undefined;
    }
  }

  initializePropertyOccupant(): void {
    if (this.mortgageApplication.IsFullApp) {
      if (this.mortgageApplication.NoPeopleAgedOver17 <= this.maxPropertyOccupants) {
        this.handlePropertyOccupantsList();
      } else {
        this.mortgageApplication.PropertyOccupants = [];
        // To do: Implement numberOfOccupantsInvalid, show error notification
      }
    }
  }

  private handlePropertyOccupantsList(): void {
    if (this.mortgageApplication.NoPeopleAgedOver17 === 0 || !this.mortgageApplication.PropertyOccupants) {
      this.mortgageApplication.PropertyOccupants = [];
    }
    for (
      let i = this.mortgageApplication.PropertyOccupants.length;
      i < this.mortgageApplication.NoPeopleAgedOver17;
      i++
    ) {
      this.mortgageApplication.PropertyOccupants.push(new PropertyOccupant());
    }
    if (this.mortgageApplication.NoPeopleAgedOver17 < this.mortgageApplication.PropertyOccupants.length) {
      this.mortgageApplication.PropertyOccupants = this.mortgageApplication.PropertyOccupants.slice(
        0,
        this.mortgageApplication.NoPeopleAgedOver17
      );
    }
  }
}
